import { Injectable, computed, signal, DestroyRef, inject } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';
import { SidebarPanel } from '../models/sidebar-panel';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  private readonly panelStack = signal<SidebarPanel[]>([]);
  readonly lastSearchQuery = signal('');

  readonly isOpen = computed(() => this.panelStack().length > 0);
  readonly currentPanel = computed(() => this.panelStack().at(-1) ?? null);
  readonly canGoBack = computed(() => this.panelStack().length > 1);

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.close());
  }

  open(panel: SidebarPanel): void {
    this.panelStack.set([panel]);
  }

  push(panel: SidebarPanel): void {
    this.panelStack.update((stack) => [...stack, panel]);
  }

  back(): void {
    this.panelStack.update((stack) => {
      if (stack.length <= 1) {
        return [];
      }
      return stack.slice(0, -1);
    });
  }

  close(): void {
    this.panelStack.set([]);
  }
}
